import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { topRatedHelpers } from 'site-modules/shared/utils/top-rated/top-rated-helpers';

import './awards-accolades.scss';

export function AwardsAccolades({
  title = '',
  content = '',
  mailTo = '',
  email = '',
  themeToUse = '',
  containerClassName = null,
  anchorClassName = 'text-primary',
}) {
  const useDarkTheme = topRatedHelpers.isDarkTheme(themeToUse);
  const useLightTheme = topRatedHelpers.isLightTheme(themeToUse);
  return (
    <div
      className={classnames('top-rated-awards-accolades text-center', containerClassName, {
        'text-gray mb-2': useDarkTheme,
        'text-gray-darker': useLightTheme,
      })}
    >
      <small className="d-block mx-auto size-12">
        <header className="fw-bold">{title}</header>
        {content}{' '}
        <a href={mailTo} className={classnames(anchorClassName)}>
          {email}
        </a>
        .
      </small>
    </div>
  );
}

AwardsAccolades.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  mailTo: PropTypes.string,
  email: PropTypes.string,
  themeToUse: PropTypes.string,
  containerClassName: PropTypes.string,
  anchorClassName: PropTypes.string,
};
